import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query'
import { inviteService } from '@/services/InviteService'
import { inviteKeys } from '@/hooks/queryKeys'
import type { InviteDto } from '@lib/dto/invite.dto'

/** Revoke an invite, refreshing the list so its new status is reflected. */
export function useRevokeInvite(): UseMutationResult<InviteDto, Error, string> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => inviteService.revoke(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: inviteKeys.lists() })
    },
  })
}
